export default "__VITE_ASSET__18716b11__"